<template>
    <van-popup
            class="city-popup"
            :value="visible"
            position="bottom"
            @close="onClose"
            @click-overlay="onClose"
            @opened="onOpened">
        <div class="city-picker">
            <div class="popup-header">
                <div class="popup-header-title">
                    省市选择
                </div>
                <van-icon class="popup-header-icon" name="cross" size="0.45rem" @click="onClose"></van-icon>
            </div>
            <div class="popup-body">
                <div class="popup-section" v-if="showHot">
                    <div class="section-header">热门城市</div>
                    <div class="section-body">
                        <ul class="city-list">
                            <li class="city-list__item"
                                v-for="item in hotList"
                                :key="item.code"
                                @click="onHotClick(item)">
                                {{item.name}}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="popup-section">
                    <div class="section-header">省市选择</div>
                    <div class="section-body">
                        <van-picker :columns="displayColumns" valueKey="name" @change="onChange"
                                    ref="picker"></van-picker>
                    </div>
                </div>
                <div class="popup-section">
                    <div class="save-btn">
                        <van-button round type="warning" @click="onSave">保存</van-button>
                    </div>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
    import {city} from "../../../utils/city.js";

    export default {
        name: "cityPicker",
        data() {
            return {
                columns: [{values: []}, {values: []}, {values: []}],
                hotList: [
                    {
                        name: '上海',
                        provinceName: '上海市',
                        cityName: '上海市',
                        districtName: '',
                        provinceId: '310000',
                        cityId: '310100',
                        districtId: '',
                        code: '310100',
                        address: ''
                    },
                    {
                        name: '杭州',
                        provinceName: '浙江省',
                        cityName: '杭州市',
                        districtName: '',
                        provinceId: '330000',
                        cityId: '330100',
                        districtId: '',
                        code: '330100',
                        address: ''
                    },
                    {
                        name: '宁波',
                        provinceName: '浙江省',
                        cityName: '宁波市',
                        districtName: '',
                        provinceId: '330000',
                        cityId: '330200',
                        districtId: '',
                        code: '330200',
                        address: ''
                    },
                    {
                        name: '濮院',
                        provinceName: '浙江省',
                        cityName: '嘉兴市',
                        districtName: '桐乡市',
                        provinceId: '330000',
                        cityId: '330400',
                        districtId: '330400',
                        code: '330483',
                        address: '濮院'
                    },
                    {
                        name: '义乌',
                        provinceName: '浙江省',
                        cityName: '金华市',
                        districtName: '义乌市',
                        provinceId: '330000',
                        cityId: '330700',
                        districtId: '330782',
                        code: '330782',
                        address: ''
                    },
                    {
                        name: '常熟',
                        provinceName: '江苏省',
                        cityName: '苏州市',
                        districtName: '常熟市',
                        provinceId: '320000',
                        cityId: '320500',
                        districtId: '320581',
                        code: '320581',
                        address: ''
                    },
                    {
                        name: '利泰',
                        provinceName: '江苏省',
                        cityName: '苏州市',
                        districtName: '太仓市',
                        provinceId: '320000',
                        cityId: '320500',
                        districtId: '320585',
                        code: '320585',
                        address: '利泰'
                    },
                    {
                        name: '无锡',
                        provinceName: '江苏省',
                        cityName: '无锡市',
                        districtName: '',
                        provinceId: '320000',
                        cityId: '320200',
                        districtId: '',
                        code: '320200',
                        address: ''
                    },
                ]
            }
        },
        computed: {
            province() {
                return Object.keys(city.province_list).map(code => {
                    return {code, name: city.province_list[code]}
                })
            },
            city() {
                return Object.keys(city.city_list).map(code => {
                    return {code, name: city.city_list[code]}
                })
            },
            district() {
                return Object.keys(city.county_list).map(code => {
                    return {code, name: city.county_list[code]}
                })
            },
            displayColumns() {
                return this.columns.slice(0, +this.columnsNum);
            }
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            },
            columnsNum: {
                type: [String, Number],
                default: 3
            },
            showHot: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onOpened() {
                this.setColumn((this.value.districtId || this.value.cityId || this.provinceId || '440000').toString())
            },
            onClose() {
                this.$emit('update:visible', false)
            },
            onChange(picker, values, i) {
                if (i === 2) return
                let code = values[i].code
                this.setColumn(code)
            },
            getList(type, code) {
                let list = this[type]
                if (type === 'province') return list
                if (type === 'city') return list.filter(val => val.code.slice(0, 2) === code.slice(0, 2))
                if (type === 'district') return [{code: code.slice(0, 4) + '00', name: '不填'}, ...list.filter(val => val.code.slice(0, 4) === code.slice(0, 4))]
            },
            setColumn(code) {
                code = code || this.province[0].code || ''
                let picker = this.$refs.picker

                picker.setColumnValues(0, this.getList('province'))

                picker.setColumnValues(1, this.getList('city', code))

                if (this.getList('city', code).length && code.slice(2, 4) === '00') {
                    code = this.getList('city', code)[0].code
                }
                picker.setColumnValues(2, this.getList('district', code))

                let provinceIndex = this.province.findIndex(val => val.code.slice(0, 2) === code.slice(0, 2))
                let cityIndex = this.getList('city', code).findIndex(val => val.code.slice(0, 4) === code.slice(0, 4))
                let districtIndex = this.getList('district', code).findIndex(val => val.code === code)
                this.$refs.picker.setIndexes([provinceIndex, cityIndex, districtIndex])
            },
            onHotClick(item) {
                this.$emit('input', item)
                this.$emit('update:visible', false)
            },
            onSave() {
                let value = this.$refs.picker.getValues()
                let obj = {
                    provinceId: value[0] ? value[0].code : '',
                    provinceName: value[0] ? value[0].name : '',
                    cityId: value[1] ? value[1].code : '',
                    cityName: value[1] ? value[1].name : '',
                    districtId: value[2] ? value[2].code : '',
                    districtName: value[2] ? value[2].name : ''
                }
                this.$emit('input', obj)
                this.$emit('update:visible', false)
            }
        }
    }
</script>

<style lang="scss">
    .city-picker {
        background-color: #fff;
    }

    .city-popup {
        background-color: transparent;
        padding: 0 0.27rem;
        box-sizing: border-box;
    }

    .city-list {
        width: 100%;

        &__item {
            width: 25%;
            display: inline-block;
            text-align: center;
            padding: 0.24rem 0;
            font-size: 0.37rem;
        }
    }

    .save-btn {
        text-align: center;
        margin-top: 0.5rem;

        .van-button {
            width: 7rem;
            margin-bottom: 2rem;
        }
    }
</style>
